import { ref, computed } from 'vue';
import { useSubscription } from '@/composables/useSubscription';

/**
 * Modal de "tu plan venció". `open` es reactivo a `isSubscriptionLapsed`,
 * no imperativo — aparece solo, sin esperar ningún 403.
 * `dismissed` es lo único manual: se resetea con `notifyExpired()` para que
 * reaparezca en el próximo intento de acción. Cerrarlo es solo cosmético.
 */
const dismissed = ref(false);

export function useRenewalOverlay() {
  const { isSubscriptionLapsed } = useSubscription();

  const open = computed(() => isSubscriptionLapsed.value && !dismissed.value);

  const dismiss = () => { dismissed.value = true; };
  const notifyExpired = () => { dismissed.value = false; };

  return { open, dismiss, notifyExpired };
}
